module.exports = require('react/lib/shallowCompare');


//////////////////
// WEBPACK FOOTER
// ./~/react-addons-shallow-compare/index.js
// module id = 80
// module chunks = 0